'use strict';
const angular = require('angular');

//Variables
var page = {}; //Set initial page title for logged in view

// Main Nav 
// Sidebar Nav
/**
 * Sidebar Nav
 * @title = Visible link title
 * @url = href link
 * @dropdown = true/false. whether nav item is a dropdown list
 * @navLinkIconClass = set style for navigation link icon
 * @subItem1 = dropdown items in case of dropdown menu
 * @subItem1 @active = true/false whether link is active
 */



var sideBarNav = [
  {
    title: 'Data and Visualization Dashboards',
    url: 'b5f6cae4-9dd9-4172-926e-72bbe0120f26',
    dropdown: true,
    navLinkIconClass: 'nav-link--policy',
    show: 'loggedIn',
    expanded: true,
    subItem1: [
      {
        title: 'Single Family',
        url: 'b5f6cae4-9dd9-4172-926e-72bbe0120f26', 
        description: ""
      }
    ]
  },
 
  
];
/*@ngInject*/
export function navServiceService() {
	 //Get Sidebar Nav
   this.getSideBarNav = function () {
    return sideBarNav;
  };

  this.getPage = function() {
    return page;
  }

  this.setPage = function(page) {
    console.log('setting page: ', page);
    page = page;
  }

  this.getDetails = function(id){
    if(_.filter(sideBarNav[0].subItem1,{url: id})[0]){
      return _.filter(sideBarNav[0].subItem1,{url: id})[0];
    }
   
  }

}

export default angular.module('appApp.navService', [])
  .service('navService', navServiceService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/navService/navService.service.js